import React, { useState } from "react";
import CashFlowStatement from "../../../../entities/DashboardPage/AccountingModule/CashFlowStatement";
import LoaderHelper from "../../../../utils/Loader/LoaderHelper";
import AuthService from "../../../../api/AuthService";
import { useAlert } from "../../../../context/AlertContext";


const CashFlowStatementPage = () => {
  const [data,setData] = useState()
  const {showAlert} = useAlert()
  const [loading, setLoading] = useState(false)

  const getCashFlow = async(month,year,viewType) =>{
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getCashFlow(month,year,viewType);
      if (result?.success) { 
        setData(result?.data);
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message,"success")
      } else {
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message,"error")
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const handleDownload = async (month,year,viewType,format) => {
    LoaderHelper.loaderStatus(true);
  
    setLoading(true)
    try {
      const result = await AuthService.handleCashFlowStatement(month,year,viewType,format);
      if (!result) {
        setLoading(false);
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "error");
      } else {
        const blob = new Blob([result], { type:"application/pdf" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `FileName.${ format}`);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        setLoading(false);
  
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  return (
    
    <CashFlowStatement getCashFlow={getCashFlow} loading={loading} handleDownload={handleDownload} data={data}/>
  )


}

export default CashFlowStatementPage;
